module.exports = __webpack_public_path__ + "img/arrow-down-from-line.f83845ec.svg";